export const GOOGLE_DRIVE_API_URL =
  'https://script.google.com/macros/s/AKfycbwQfFwCqJoTP0xBdBFpPAiDuFg_GRSWAycC7hW10sa_5Z5WrXWmMsc5ZNXjnjNUA6rieQ/exec';
